import { MenuItem, withStyles, Popper,  Paper, Fade } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { compose } from 'recompose';
import { withAppConfig } from '../../../../../../../appConfigContext';
import { withUserProfile } from '../../../../../../../userProfile/userProfileContext';
import { Resize, SearchBar } from '../../../../../../../layout/layoutHeader/components';
import { MoreVert } from '@material-ui/icons';
import PickupsGridFilter from '../../Grid/Filter/GridFilter';
import ShowHideColumns from '../../../../../../../layout/layoutHeader/showHideColumns';
import ExportData from '../../../../../../../layout/layoutHeader/components/ExportData';
import {
  EditPickup,
  CreatePickup,
  NoFreightPickup,
  MergePickup,
  VoidAndUnvoidPickup,
  PastPickup
} from './GridHeaderControls';
import WatchTutorial from '../../../../../../InAppTutorial/WatchTutorial';
import appConstants from '../../../../../../../appConstants';
import ClearAllFilterButton from '@dataGrid/components/columnFilters/ClearAllFilterButton';
const styles = (theme) => ({
  iconLayout: {
    float: 'left',
    color: theme.iconColor,
    '&>span': {
      padding: '10px 10px',
      color: theme.iconColor
    }
  },
  pickupsFilterContainer: {
    marginRight: 8,
    marginTop: 3
  },
  mainMenu: {
    background: theme.gridBGColor,
    borderRadius: '0px 0px 4px 4px',
    width: '170px'
  },
  toggledMenu: {
    display: 'flex'
  },
  menuItem: {
    padding: '6px 0px',
    "&:hover": {
      background: theme.customMultiSelectColor,
    },
  },
  headerIconStyles: {
    padding: '10px 10px',
    borderLeft: `1px solid ${theme.AppBGColor}`,
    cursor: 'pointer'
  },
  moreIcon: {
    fontSize: '21px'
  },
  customPopper: {
    zIndex: 999,
    marginTop: 0,
  }
});
const PickupsHeader = (props) => {
  const { classes, userData, configJSON, ...other } = props;
  const [pickupHeaderMenuAnchor, setPickupHeaderAnchor] = useState(null);
  const [gridApi, setGridApi] = useState(null);
  useEffect(() => {
    const setGridApiCallback = (api) => setGridApi(api);
    props.stack.layoutManager.eventHub.on(`${props.headerId}_setGridApi`, setGridApiCallback);
    return () => {
      props.stack.layoutManager.eventHub.off(`${props.headerId}_setGridApi`, setGridApiCallback);
    };
  }, []);

  const openPickupHeaderMenu = (event) => {
    setPickupHeaderAnchor(event.currentTarget);
  };

  const closePickupHeaderMenu = () => {
    setPickupHeaderAnchor(null);
  };

  const isAppTutorialEnabled = configJSON.appTutorialEnabledComponents?.includes(
    appConstants.gridNames.PickupsGrid
  );
  return (
    <>
      <SearchBar eventHub={props.stack.layoutManager.eventHub} headerId={props.headerId} />
      <div className={`${classes.iconLayout} ${classes.pickupsFilterContainer} glHeaderIcons`}>
        <PickupsGridFilter stack={props.stack} headerId={props.headerId} />
      </div>
      <ClearAllFilterButton gridApi={gridApi} />
      <CreatePickup eventHub={props.stack.layoutManager.eventHub} configJSON={configJSON}/>
      <EditPickup eventHub={props.stack.layoutManager.eventHub} headerId={props.headerId} />
      <VoidAndUnvoidPickup
        eventHub={props.stack.layoutManager.eventHub}
        headerId={props.headerId}
        terminalCode={userData.userProfile.terminal.code}
      />
      <MergePickup eventHub={props.stack.layoutManager.eventHub} headerId={props.headerId} />
      <NoFreightPickup
        eventHub={props.stack.layoutManager.eventHub}
        headerId={props.headerId}
        terminalOffset={userData.userProfile.terminal.offset}
      />
      <div className={`${classes.headerIconStyles} ${classes.iconLayout} glHeaderIcons`}>
        <ShowHideColumns api={gridApi} userData={props.userData} />
      </div>
      <Resize {...other} />
      <span
        onMouseLeave={closePickupHeaderMenu}
        className={`${classes.headerIconStyles} ${classes.iconLayout}`}>
        <div className={classes.toggledMenu} onMouseEnter={openPickupHeaderMenu}>
          <MoreVert className={classes.moreIcon} />
        </div>
        <Popper
          id="pickupHeaderMoreMenu"
          open={Boolean(pickupHeaderMenuAnchor)}
          anchorEl={pickupHeaderMenuAnchor}
          onClose={closePickupHeaderMenu}
          transition
          className={classes.customPopper}
          modifiers={{
            offset: {
              enabled: true,
              offset: '12,0'
            }
          }}
          placement="bottom-end">
          {({ TransitionProps }) => (
            <Fade {...TransitionProps} timeout={{ exit: 500 }}>
              <Paper className={classes.mainMenu}>
                <MenuItem className={classes.menuItem}>
                  <PastPickup
                    eventHub={props.stack.layoutManager.eventHub}
                    headerId={props.headerId}
                    terminalCode={userData.userProfile.terminal.code}
                  />
                </MenuItem>
                <MenuItem className={classes.menuItem}>
                  <ExportData userData={userData} gridApi={gridApi} showLabel {...other} />
                </MenuItem>
                {isAppTutorialEnabled && (
                  <MenuItem className={classes.menuItem}>
                    <WatchTutorial showLabel componentId={appConstants.gridNames.PickupsGrid} />
                  </MenuItem>
                )}
              </Paper>
            </Fade>
          )}
        </Popper>
      </span>
    </>
  );
};

export default compose(withStyles(styles), withAppConfig, withUserProfile)(PickupsHeader);
